export const EXPORT_DATA_TYPES = {
  PLAN_AND_RECORD: 'planAndRecord',
  DAILY_REPORT_AND_RECORD: 'dailyReportAndRecord',
  PLAN_DETAIL: 'planDetail',
  DAILY_REPORT_DETAIL: 'dailyReportDetail',
  PLAN_WORKER_COUNTS: 'planWorkerCounts',
  DAILY_REPORT_WORKER_COUNTS: 'dailyReportWorkerCounts',
} as const
